// preference actions
export const SET_PREFERENCE = "SET_PREFERENCE";
export const RESET_PREFERENCES = "RESET_PREFERENCES";
export const LOAD_PREFERENCES = "LOAD_PREFERENCES";

// preference types
export const AUTO_SAVE = "AUTO_SAVE";
export const DOCK_POSITION = "DOCK_POSITION";
export const UNITY_MODE = "UNITY_MODE";
export const PANE_QUIZ_ORIENTATION = "PANE_QUIZ_ORIENTATION";
export const PANE_QUIZ_SIZE = "PANE_QUIZ_SIZE";
export const PANE_WORKSHEET_ORIENTATION = "PANE_WORKSHEET_ORIENTATION";
export const PANE_WORKSHEET_SIZE = "PANE_WORKSHEET_SIZE";

// preference groups
export const VALID_PREFERENCES = [
  AUTO_SAVE,
  DOCK_POSITION,
  UNITY_MODE,
  PANE_QUIZ_ORIENTATION,
  PANE_QUIZ_SIZE,
  PANE_WORKSHEET_ORIENTATION,
  PANE_WORKSHEET_SIZE
];
